import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import LeadershipRoleFormLayer from "../components/LeadershipRoleFormLayer";

const LeadershipRoleFormPage = () => {
    return (
        <MasterLayout>
            <LeadershipRoleFormLayer />
        </MasterLayout>
    );
};

export default LeadershipRoleFormPage;
